import { storeAsync } from '@/app-module';

const Layout = () => import('@/modules/layout/components/layout');
const geteFacturaModule = () => import('@/modules/efactura/efactura-store');
const eFacturaPage = () => import('@/modules/efactura/components/efactura.vue');


const importeFacturaStore = () =>
    geteFacturaModule().then(async (storeModule) => {
        if (!storeAsync().hasModule('efactura')) await storeAsync().registerModule('efactura', storeModule.default);
        else return;
    });

export default [
    {
        path: '',
        exact: true,
        component: Layout,
        meta: { auth: true },
        children: [
            {
                name: 'efactura',
                path: '/efactura',
                component: eFacturaPage,
                exact: true,
                meta: { auth: true },
                beforeEnter: (to, from, next) => {
                    importeFacturaStore().then(() => {
                        next();
                    });
                },
            },
        ],
    },
];
